
import LinkedInSettingsCard from '@/components/linked-in/LinkedInSettingsCard.vue';
import LinkedInLoginCard from '@/components/linked-in/LinkedInLoginCard.vue';
import PlatformLatestPostsCard from '@/components/social/PlatformLatestPostsCard.vue';
import { SOCIAL_PLATFORMS_METADATA } from '@/constants';
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { Bot, LinkedInPlatformData, SupportedPlatform } from 'ignite360-core';
import _merge from 'lodash.merge';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'project-social-platform-linked-in',
  components: {
    LinkedInLoginCard,
    LinkedInSettingsCard,
    PlatformLatestPostsCard,
  },
})
export default class ProjectSocialPlatformLinkedIn extends mixins(ProjectViewMixin) {
  readonly linkedInPlatform = SupportedPlatform.LinkedIn;

  get isPlatformConnected(): boolean {
    const meta = SOCIAL_PLATFORMS_METADATA.find((m) => m.value === SupportedPlatform.LinkedIn);
    return !!this.bot && !!meta?.isConnected?.(this.bot);
  }

  onConnect(data: Partial<LinkedInPlatformData>) {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.LinkedIn]: data,
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }

  onDisconnect() {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.LinkedIn]: {
          _id: '',
          type: '',
        },
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }
}
